import { useMutation } from "@apollo/client";
import { Button, ButtonGroup } from "@blueprintjs/core";
import _ from "lodash";
import { useEffect, useState } from "react";
import {
  Article,
  ArticlePriceTier,
  CreateArticlePriceTierInput,
} from "../../../../api/schema";
import { ValuesVariables } from "../../../../components/form/InputForm";
import { UserLanguage } from "../../../../lang/lang";
import { CreateArticlePriceTierMutation } from "../../helper/graphql";
import { PriceTier } from "./PriceTier";

interface ArticlePriceSettingsProps {
  article: Article;
  on_created: () => void;
}

export const ArticlePriceInformation = (props: ArticlePriceSettingsProps) => {
  const [selected_tier, set_selected_tier] = useState<ArticlePriceTier | null>(
    null
  );

  const [price_tiers, set_price_tiers] = useState<ArticlePriceTier[]>([]);

  useEffect(() => {
    // console.log("reordering price tiers!", props, selected_tier);

    if (props.article.price_information.length === 0) {
      set_selected_tier(null);
      set_price_tiers([]);
      return;
    }

    const ordered = _.orderBy(props.article.price_information, "tier");
    set_price_tiers(ordered);

    if (selected_tier) {
      const t = _.find(props.article.price_information, {
        id: selected_tier.id,
      });
      if (t) {
        set_selected_tier(t);
        return;
      }
    } else if (props.article.price_information.length > 0) {
      set_selected_tier(ordered[0]);
      return;
    }
    set_selected_tier(null);
  }, [props, selected_tier]);

  const [create_tier_mutation] = useMutation<
    ArticlePriceTier,
    ValuesVariables<CreateArticlePriceTierInput>
  >(CreateArticlePriceTierMutation);

  const create_next_tier = () => {
    if (!props.article) return;

    let new_tier = 1;
    if (price_tiers.length > 0)
      new_tier =
        _(props.article.price_information).orderBy("tier").last()!.tier + 1;

    // console.log("new tier", new_tier);

    create_tier_mutation({
      variables: {
        values: {
          article_id: props.article.id,
          tier: new_tier,
        },
      },
    }).then((res) => {
      // console.log("result", res);
      if (res.data) props.on_created();
    });
  };

  return (
    <div className="aw_api">
      <div className="aw_api_header">
        <h3>{UserLanguage().data.article.price_information.label}</h3>
      </div>
      <div>
        <ButtonGroup>
          {_.map(price_tiers, (tier) => (
            <Button
              text={tier.tier}
              key={tier.id}
              intent={tier === selected_tier ? "primary" : "none"}
              onClick={() => set_selected_tier(tier)}
            />
          ))}
          <Button intent="success" icon="plus" onClick={create_next_tier} />
        </ButtonGroup>
      </div>
      <PriceTier
        tier={selected_tier}
        article={props.article}
        on_changed={props.on_created}
        key={"pt_" + selected_tier?.id}
      />
    </div>
  );
};
